import {strEnum} from "../../types";

export const TCI_ASSET_TAGS_COMPONENT_MODE = strEnum([
    "SELECT_ONLY",
    "FULLY_FUNCTIONAL"
]);

export const TCI_ASSET_TAGS_COMPONENT_LAYOUT = strEnum([
    "VERTICAL_CHECKBOX",
    "HORIZONTAL_FLOW"
]);

export type TCI_ASSET_TAGS_COMPONENT_MODE = keyof typeof TCI_ASSET_TAGS_COMPONENT_MODE;
export type TCI_ASSET_TAGS_COMPONENT_LAYOUT = keyof typeof TCI_ASSET_TAGS_COMPONENT_LAYOUT;

export interface ITCIAssetTag {
    /**
     * tag name which is unique globally
     */
    name: string;
    /**
     * the number of assets to which this tag is attached
     */
    assetCount?: number;
}

/**
 *
 */
export interface ITCIAssetTagsList {
    tags: ITCIAssetTagsInfo[];
}

/**
 *
 */
export interface ITCISimplifiedAssetTagsList {
    // name = tag name, string[] = an array of asset ids
    [name: string]: string[];
}

/**
 *
 */
export interface ITCIAssetTagsInfo {
    id: string;
    name: string;
    userName: string;
    subscriptionId: string;
    agentIds?: string[];
    appIds?: string[];
    connectionIds?: string[];
    marketplaceIds?: string[];
}

// tslint:disable-next-line:no-empty-interface
export interface ITCIApplicationTags extends ITCIAssetTagsInfo {
}

// tslint:disable-next-line:no-empty-interface
export interface ITCIConnectionTags extends ITCIAssetTagsInfo {
}

// tslint:disable-next-line:no-empty-interface
export interface ITCIListingTags extends ITCIAssetTagsInfo {
}

/**
 * Asset Tag mapping for the gsbc + uid + tagId
 */
export interface ITCIOrgAssetInfo {
    /**
     * application tags
     */
    applications?: ITCIApplicationTags;
    /**
     * connection tags
     */
    connections?: ITCIConnectionTags;
    /**
     * Listing tags
     */
    listings?: ITCIListingTags;
}

/**
 * TCI assets that can be tagged.
 */
export interface ITCITaggable {
    /**
     * app tags
     */
    tags?: ITCIAssetTag[];
    /**
     * app tags added
     */
    tagsAdded?: ITCIAssetTag[];
    /**
     * app tags removed
     */
    tagsRemoved?: ITCIAssetTag[];
}

export const TAG_FILTER_SORT = strEnum([
    "top",
    "bottom",
    "alphabetical"
]);

export type TAG_FILTER_SORT = keyof typeof TAG_FILTER_SORT;

